<template>
  <div :class="!isTyping ? status : ''" class="form-group st_input">
    <label v-if="label" :for="`uid_${itemUid}`">
      {{ label }}
    </label>
    <div class="input-wrapper">
      <input
        class="form-control"
        :id="`uid_${itemUid}`"
        :class="inputClass"
        :type="type"
        :maxlength="maxlength"
        :placeholder="placeholder"
        :readonly="isReadonly? 'readonly' : null"
        @input="isInputed"
        @change="isChanged"
        v-model="inputVal"
        :disabled="disabled"
        @keyup.enter="$emit('keyup:enter', inputVal)">
    </div>
    <div class="feedback">
      {{ feedback }}
    </div>
  </div>
</template>

<script>
  export default {
    name:  'Input',
    props: {
      inputClass: {
        type:    String,
        default: '',
      },
      status: {
        type:    String,
        default: '',
      },
      label: {
        type:    String,
        default: '',
      },
      type: {
        type:    String,
        default: 'text',
      },
      placeholder: {
        type:    String,
        default: '',
      },
      value: {
        type:    [String, Number],
        default: '',
      },
      maxlength: {
        type:    String,
        default: '524288',
      },
      isReadonly: {
        type:    Boolean,
        default: false,
      },
      feedback: {
        type:    String,
        default: '',
      },
      disabled: {
        type:    Boolean,
        default: false,
      },
    },
    data () {
      // eslint-disable-next-line no-underscore-dangle
      const itemUid = this._uid
      return {
        itemUid:  itemUid,
        inputVal: this.value,
        isTyping: false,
      }
    },
    watch: {
      inputVal (val) {
        this.$emit('input', val)
      },
      value (val) {
        this.inputVal = val
      },
    },
    methods: {
      isInputed () {
        this.isTyping = true
      },
      isChanged (e) {
        this.$emit('change', e.target.value)
        this.isTyping = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .st_input {
    &.form-group {
      label {
        color: $st_color_main_light;
        margin-left: 0.5rem;
      }

      .input-wrapper {
        position: relative;
      }

      .form-control {
        border: 2px solid $st_color_gray_lighter;
        border-radius: 0.125rem;

        &:focus {
          box-shadow: none;
          border: 1px solid $st_color_main_lighter;
        }

        &[readonly] {
          border: 1px solid $st_color_gray_light;

          &:focus {
            border: 1px solid $st_color_gray_light;
          }

          &:hover {
            cursor: not-allowed;
          }
        }
      }

      input:disabled {
        background-color: $st_color_gray_lighter;
        border-color: $st_color_gray_light;
      }

      input::placeholder {
        color: $st_color_gray_light;
        font-weight: 400;
      }

      .feedback {
        display: none;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 0.75rem;
      }

      &.is-valid, &.is-invalid, &.is-warning {
        .form-control {
          border: 1px solid;
          padding-right: 2.5rem;
        }
      }

      &.is-valid {
        .form-control {
          border-color: $st_color_success;
        }

        .input-wrapper:after {
          font-family: "Material Icons";
          font-weight: 900;
          content: '\e876';
          color: $st_color_success;
          text-align: center;
          position: absolute;
          right: 0.5rem;
          top: 0.5rem;
          width: 1.5rem;
        }

        .feedback {
          display: block;
          color: $st_color_success;
        }
      }

      &.is-invalid {
        .form-control {
          border-color: $st_color_error;
        }

        .input-wrapper:after {
          font-family: "Material Icons";
          font-weight: 900;
          content: '\e5cd';
          color: $st_color_error;
          text-align: center;
          position: absolute;
          right: 0.5rem;
          top: 0.5rem;
          width: 1.5rem;
        }

        .feedback {
          color: $st_color_error;
          display: block;
        }
      }

      &.is-warning {
        .form-control {
          border-color: $st_color_warning;
        }

        .input-wrapper:after {
          font-family: "Material Icons";
          font-weight: 900;
          content: '\e645';
          color: $st_color_warning;
          text-align: center;
          position: absolute;
          right: 0.5rem;
          top: 0.5rem;
          width: 1.5rem;
        }

        .feedback {
          display: block;
          color: $st_color_warning;
        }
      }
    }
  }

  .coupon__input--width {
    max-width: 210px;
  }
</style>
